import DOMPurify from "dompurify";

const EXTERNAL_EMAIL_ALLOWED_TAGS = [
  // headers
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  // Text formatting
  "b",
  "blockquote",
  "br",
  "em",
  "i",
  "p",
  "span",
  "strike",
  "strong",
  "u",
  // Layout
  "div",
  "hr",
  "table",
  "tbody",
  "td",
  "th",
  "thead",
  "tr",
  // Media & Links
  "a",
  "img",
  // Lists
  "li",
  "ol",
  "ul",
];

const sanitizeEmailHtml = (html: string) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: EXTERNAL_EMAIL_ALLOWED_TAGS,
  });
};

export default sanitizeEmailHtml;
